import { ErrorHandler, Injector, Injectable } from '@angular/core';
import { RollbarService } from './services/common/rollbar.service';

import { environment } from '../environments/environment';

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  /**
   * List of errors handled
   * @type {Array<any>}
   */
  errors: Array<any> = [];

  /**
   * Constant for one hour for JS date
   * @type {number}
   */
  ONE_HOUR: number = 3600000;

  /**
   * Constructor
   * @param {Injector} private injector Angular injector to inject a service
   */
  constructor(private injector: Injector) {}

  /**
   * Check if error is already present in list of errors handled within the past one hour
   * @param  {any}     errorToCheck Error to check presence for
   * @return {boolean}              Indicates if error is already present and handled
   */
  checkErrorPresence(errorToCheck: any): boolean {
    let currentDate: Date = new Date();
    for (let errorItem of this.errors) {
      if (errorToCheck.name == errorItem.error.name && errorToCheck.message == errorItem.error.message && errorToCheck.stack == errorItem.error.stack && Number(currentDate) - this.ONE_HOUR < Number(errorItem.occurrenceTime)) return true;
    }
    return false;
  }

  /**
   * Handle error
   * @param {any} error Error to handle
   */
  handleError(error: any) {
    // do something with the exception
    if (error) {
      error = error.originalError || error;
      console.error(error);
      if (this.errors.length > 100) this.errors.shift();
      if (this.checkErrorPresence(error)) {
        console.log('Error already handled');
        return;
      }
      this.errors.push({ error: error, occurrenceTime: new Date() });
      console.log('Error sent to rollbar');
      if (!environment.production) return;
      var rollbar = this.injector.get(RollbarService);
      rollbar.error(error);
    }
  }
}
